const answeredValue = (response) => {
  if(response.score !== null && response.score !== undefined) {
    return response.score;
  }
  return response.answers.length ? response.answers : response.text;
};

// Rules look like { question: "nps", gte: 7 }, { question: "nps", lte: 6 } or { question: "level", in: ["Beginner"] }.
export default function matchesShowIf(rule, responses) {
  if(!rule) {
    return true;
  }

  const response = responses[rule.question];
  if(!response) {
    return false;
  }

  const value = answeredValue(response);
  const meetsMinimum = rule.gte === undefined || value >= rule.gte;
  const meetsMaximum = rule.lte === undefined || value <= rule.lte;
  const isAllowedOption = rule.in === undefined || [].concat(value).some((item) => rule.in.includes(item));

  return meetsMinimum && meetsMaximum && isAllowedOption;
}
